import dataset from "./dataset_instagram-post-scraper_2026-01-29_19-20-54-177.json";

// Sort posts by likesCount (desc), then timestamp (desc), export URLs only
const sortedItems = (Array.isArray(dataset) ? dataset : [])
    .filter(item => item && item.url)
    .sort((a, b) => {
        const la = Number(a.likesCount || 0);
        const lb = Number(b.likesCount || 0);
        if (lb !== la) return lb - la;
        const ta = Date.parse(a.timestamp || 0) || 0;
        const tb = Date.parse(b.timestamp || 0) || 0;
        return tb - ta;
    });

export const instagramUrls = Array.from(new Set(sortedItems.map(item => item.url)));